import React from 'react';
import { Route } from 'react-router';
import InstructionGeneratorCreatePage from './InstructionGeneratorCreatePage';
import InstructionGeneratorListPage from './InstructionGeneratorListPage';
import FilesWidget from '../../FilesWidget/components';

export default function InstructionGeneratorPage (props) {
  const { match } = props;

  return (<div>
    <Route component={InstructionGeneratorListPage} path={`${match.url}/list`} exact/>
    <Route component={InstructionGeneratorCreatePage} path={`${match.url}/create/order/:orderId`} exact/>
    <Route component={InstructionGeneratorCreatePage} path={`${match.url}/create/order/:orderId/version/:versionId`} exact/>
    <FilesWidget/>
  </div>);
}
